import {
  Autocomplete,
  Checkbox,
  Chip,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Field, useFormikContext } from "formik";
import debounce from "lodash.debounce";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { AutocompleteText } from "../../../component/AutoComplete";
import CommonTextField from "../../../component/Input";
import DropDownSelect from "../../../component/Select";
import { getToolTipIcon, HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan, ErrorContent } from "../style";
import DateRangePickerComp from "./DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomDatePicker } from "../../coversheet/components/style";
import dayjs from "dayjs";

const JOB_DATE_FMT = "DD MMM YYYY";

const parseJobDateValue = (raw) => {
  if (!raw) return null;
  const d = dayjs(raw, JOB_DATE_FMT);
  return d.isValid() ? d : null;
};

const EditIndex = ({
  editData,
  menuItemData,
  loading,
  rowSize = false,
  marginTop,
  initializedPopup = {
    current: true,
  },
  iconVisible = false,
}) => {
  const [openDatePicker, setOpenDatePicker] =useState("");
  const { values, errors, setFieldValue } = useFormikContext();
  const initialized = useRef(false);
  const formatDisplay = (val) =>
  val !== "" && val !== undefined && val !== null
    ? parseFloat(Number(val).toFixed(2))
    : "";
  const [localValue, setLocalValue] = React.useState({
    job_title: values.job_title || "",
    company_name: values.company_name || "",
    location: values.location || "",
    work_location_type: values.work_location_type || "",
    req_id: values.req_id || "",
    shift: values.shift || "",
    bu_department_team: values.bu_department_team || "",
    interview_type: values.interview_type || "",
    shift_value: values.shift_value || "",
    reports_to: values.reports_to || "",
    location_targets_value: values.location_targets_value || "",
    certificates_value: values.certificates_value || "",
    employer_targets_value: values.employer_targets_value || "",
    languages_value: values.languages_value || "",
     min: formatDisplay(values["pay_rate"]?.["min"]),
  max: formatDisplay(values["pay_rate"]?.["max"]),
    specific_degree: values.specific_degree || "",
    required_years_for_industry: values.required_years_for_industry || "",
  });
const handleCurrencyBlur = (e, item) => {
  const rounded = formatDisplay(e.target.value);
  setLocalValue((prev) => ({
    ...prev,
    [item.currency]: rounded,
  }));
};
  useEffect(() => {
    if (!initialized.current || !initializedPopup?.current) {
      setLocalValue({
        job_title: values.job_title || "",
        company_name: values.company_name || "",
        location: values.location || "",
        work_location_type: values.work_location_type || "",
        req_id: values.req_id || "",
        shift: values.shift || "",
        bu_department_team: values.bu_department_team || "",
        interview_type: values.interview_type || "",
        shift_value: values.shift_value || "",
        reports_to: values.reports_to || "",
        location_targets_value: values.location_targets_value || "",
        certificates_value: values.certificates_value || "",
        employer_targets_value: values.employer_targets_value || "",
        languages_value: values.languages_value || "",
         min: formatDisplay(values["pay_rate"]?.["min"]),
  max: formatDisplay(values["pay_rate"]?.["max"]),
        specific_degree: values.specific_degree || "",
        required_years_for_industry: values.required_years_for_industry || "",
      });
    }
  }, [values]);

  const handleInputChange = (e, item) => {
    setLocalValue((prev) => ({
      ...prev,
      [item.titleName]: e.target.value,
    }));
    debouncedOnListChange(item.onChange, e, item.titleName);
  };

  const handleListChange = (e, item, index) => {
    const updatedValues = [...values[item.titleName]];
    updatedValues[index] = e.target.value;
    setLocalValue((prev) => ({
      ...prev,
      [item.titleName]: updatedValues,
    }));
    debouncedOnListChange(item.onListChange, updatedValues);
  };

  const handleCurrencyChange = (e, item) => {
    setLocalValue((prev) => ({
      ...prev,
      [item.currency]: e.target.value,
    }));

    debouncedOnListChange(
      item.handleCurrencyChange,
      e,
      item.titleName,
      item.currency
    );
  };

  const debouncedOnListChange = useCallback(
    debounce((handleFunction, updated, key, key1) => {
      initialized.current = true;
      handleFunction(updated, key, key1);
    }, 0),
    []
  );

  return (
    <CommonGrid2
      container
      columnSpacing={3}
      rowSpacing={loading ? 0 : 3}
      marginTop={marginTop}
    >
      {editData?.map((item, index) => {
        return (
          <CommonGrid2
            item
            size={{
              xs: 12,
              md: item.customSize
                ? item.customSize
                : item.type === "additional" || rowSize
                ? 6
                : 4,
              sm: 6,
            }}
            key={item.title}
            gap={"5px"}
            display={"flex"}
            flexDirection={item.component === "switch" ? "row" : "column"}
            // justifyContent={"flex-start"}
          >
            {loading ? (
              <HandleSkeletion height={100} />
            ) : (
              <>
                {item.component !== "split-part" && (
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      width={"100%"}
                      gap={"10px"}
                      flexWrap={"wrap"}
                    >
                      <Typography variant="p" color="#344054" fontSize="15px">
                        {item.title}
                        {item.required && (
                          <CustomizeSpan color={"red"}> *</CustomizeSpan>
                        )}
                      </Typography>
                      {item.anomaly_content}
                      {iconVisible && item.content ? (
                        item.content
                      ) : (
                        <Fragment>
                          {values?.["key_colors"]?.[
                            item?.titleName || item?.toggleName
                          ] === "inferred"
                            ? getToolTipIcon("Inferred")
                            : values?.["key_colors"]?.[
                                item?.titleName || item?.toggleName
                              ] === "extracted"
                            ? ""
                            : values?.["key_colors"]?.[
                                item?.titleName || item?.toggleName
                              ] === "user_added"
                            ? getToolTipIcon("User Added")
                            : ""}
                        </Fragment>
                      )}
                      {item.field_type && (
                        <CommonGrid2
                          display={"flex"}
                          alignItems={"center"}
                          gap={"5px"}
                          background="#EBF8FF"
                          padding={"1px 10px 1px 8px"}
                          borderRadius={"50px"}
                          width={"max-content"}
                        >
                          {item.icon}
                          <Typography variant="subtitle3">
                            {item.field_type}
                          </Typography>
                        </CommonGrid2>
                      )}

                      {/* {item?.iconVisible && item?.content} */}
                    </CommonGrid2>
                    {item.type === "additional" && (
                      <Switch
                        checked={values[item.toggleName] || false}
                        onChange={(event) => {
                          item.handleChangeSwitch(
                            item.toggleName,
                            event.target.checked
                          );
                        }}
                      />
                    )}
                  </CommonGrid2>
                )}
                {item.component === "input" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          placeholder={item.title}
                          padding="10px"
                          error={Boolean(form.errors[item.titleName])}
                          defaultValue={item.name === "-" ? "" : item.name}
                          value={localValue[item.titleName]}
                          onChange={(e) => {
                            handleInputChange(e, item);
                          }}
                          helperText={form.errors[item.titleName]}
                          // onBlur={handleBlur}
                        />
                      );
                    }}
                  </Field>
                )}
                {item.component === "number" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          type="number"
                          placeholder={item.title}
                          padding="10px"
                          error={Boolean(form.errors[item.titleName])}
                          defaultValue={item.name === "-" ? "" : item.name}
                          value={localValue[item.titleName]}
                          onChange={(e) => {
                            if (e.target.value < 0) {
                              e.target.value = 0;
                            } else if (e.target.type === "number") {
                              if (["-", "e"].includes(e.key)) {
                                e.preventDefault();
                              } else handleInputChange(e, item);
                            }
                          }}
                          helperText={form.errors[item.titleName]}
                        />
                      );
                    }}
                  </Field>
                )}
                {item.component === "split-part" && (
                  <CommonGrid2 container spacing={2}>
                    {item.data.map((innerItem) => (
                      <CommonGrid2
                        size={6}
                        display={"flex"}
                        flexDirection={"column"}
                        gap={"5px"}
                      >
                        <CommonGrid2
                          display={"flex"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          width={"100%"}
                        >
                          <CommonGrid2
                            display={"flex"}
                            alignItems={"center"}
                            width={"100%"}
                            gap={"10px"}
                          >
                            <Tooltip
                              arrow
                              title={innerItem.title}
                              placement="top"
                            >
                              <Typography
                                variant="p"
                                color="#344054"
                                fontSize="15px"
                                overflow={"hidden"}
                                textOverflow={"ellipsis"}
                                whiteSpace={"nowrap"}
                              >
                                {innerItem.title}
                              </Typography>
                            </Tooltip>
                            {iconVisible && (
                              <CustomDiv display={"flex"}>
                                {values?.["key_colors"]?.[
                                  innerItem?.titleName || innerItem?.toggleName
                                ] === "inferred"
                                  ? getToolTipIcon("Inferred")
                                  : values?.["key_colors"]?.[
                                      innerItem?.titleName ||
                                        innerItem?.toggleName
                                    ] === "extracted"
                                  ? ""
                                  : values?.["key_colors"]?.[
                                      innerItem?.titleName ||
                                        innerItem?.toggleName
                                    ] === "user_added"
                                  ? getToolTipIcon("User Added")
                                  : ""}
                              </CustomDiv>
                            )}
                          </CommonGrid2>
                          {innerItem.type === "additional" && (
                            <Switch
                              checked={values[innerItem.toggleName] || false}
                              onChange={(event) => {
                                innerItem.handleChangeSwitch(
                                  innerItem.toggleName,
                                  event.target.checked
                                );
                              }}
                            />
                          )}
                        </CommonGrid2>

                        {innerItem.component === "input" && (
                          <Field name={innerItem.titleName}>
                            {({ field, form }) => {
                              return (
                                <CommonTextField
                                  placeholder={innerItem.title}
                                  padding="10px"
                                  error={Boolean(
                                    form.errors[innerItem.titleName]
                                  )}
                                  defaultValue={
                                    innerItem.name === "-" ? "" : innerItem.name
                                  }
                                  value={localValue[innerItem.titleName]}
                                  onChange={(e) => {
                                    handleInputChange(e, innerItem);
                                  }}
                                  helperText={form.errors[innerItem.titleName]}
                                  // onBlur={handleBlur}
                                />
                              );
                            }}
                          </Field>
                        )}

                        {innerItem.component === "dropDown" && (
                          <DropDownSelect
                            marginTop="0px"
                            title={innerItem.title}
                            removeAnimation={true}
                            data={values[innerItem.dropDownData]}
                            error={Boolean(errors[innerItem.titleName])}
                            helperText={errors[innerItem.titleName]}
                            id={innerItem.titleName}
                            value={values[innerItem.titleName]}
                            handleChange={(e) =>
                              innerItem.handleDropdownChange(
                                e,
                                innerItem.titleName
                              )
                            }
                          />
                        )}
                      </CommonGrid2>
                    ))}
                  </CommonGrid2>
                )}
                {item.component === "input-select" && (
                  <CommonTextField
                    showSelect={true}
                    placeholder={"Enter the rate"}
                    menuItemData={menuItemData}
                    onBlur={(e) => handleCurrencyBlur(e, item)} 
                    onChange={(e) => {
                      handleCurrencyChange(e, item);
                    }}
                    currency={values[item.titleName]?.[item.currencyValue]}
                    padding="10px"
                    handleCurrencyChange={(e) => {
                      item.handleCurrencyDropdownChange(
                        e,
                        item.titleName,
                        item.currencyValue
                      );
                    }}
                    error={errors[item.titleName]?.[item.currency]}
                    helperText={errors[item.titleName]?.[item.currency]}
                    value={localValue?.[item.currency]}
                  />
                )}
                {item.component === "dropDown" && (
                  <DropDownSelect
                    marginTop="0px"
                    title={item.title}
                    removeAnimation={true}
                    data={values[item.dropDownData]}
                    error={Boolean(errors[item.titleName])}
                    helperText={errors[item.titleName]}
                    id={item.titleName}
                    value={values[item.titleName]}
                    handleChange={async (e) => {
                      await item.handleDropdownChange(e, item.titleName);
                      initialized.current = false;
                    }}
                  />
                )}

                {item.component === "single-calender" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const isPairedJobDate =
                        item.titleName === "start_date" ||
                        item.titleName === "end_date";
                      const isError =
                        Boolean(form.errors[item.titleName]
                         
                          
                            );
                              console.log("form.errors", form.touched,isError);

                      const helperText = isError
                        ? form?.errors[item.titleName]
                        : "";

                      const startD = parseJobDateValue(form.values.start_date);
                      const endD = parseJobDateValue(form.values.end_date);
                      const minDate =
                        item.titleName === "end_date" && startD
                          ? startD
                          : undefined;
                      const maxDate =
                        item.titleName === "start_date" && endD
                          ? endD
                          : undefined;

                      return (
                        <>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <CustomDatePicker
                                open={openDatePicker === item.titleName}
                                onOpen={() =>
                                  setOpenDatePicker(item.titleName)
                                }
                                onClose={() => setOpenDatePicker("")}
                              desktopModeMediaQuery="(min-width:0px)"
                              minDate={minDate}
                              maxDate={maxDate}
                              error={isError}
                              onChange={(newValue) => {
                                item.handleDatePicker(item.titleName, newValue);
                                // if (isPairedJobDate) {
                                //   window.setTimeout(() => {
                                //     form.validateField("start_date");
                                //     form.validateField("end_date");
                                //   }, 0);
                                // }
                              }}
                              value={
                                form?.values?.[item?.titleName]
                                  ? dayjs(
                                      form.values[item.titleName],
                                      JOB_DATE_FMT
                                    )
                                  : null
                              }
                              format={JOB_DATE_FMT}
                              views={["year", "month", "day"]}
                             slotProps={{
                              textField: {
                                  onClick: () =>
                                    setOpenDatePicker(item.titleName),
                                inputProps: {
                                  readOnly: true,
                                },
                                sx: {
                                  "& .MuiInputBase-input": {
                                    cursor: "pointer",
                                    color: form?.values?.[item?.titleName]
                                      ? "#000"
                                      : "#5e5c5c",
                                    opacity: 1,
                                    backgroundColor: "#fff",
                                  },

                                  "& .MuiButtonBase-root": {
                                    backgroundColor: "#ffffff",
                                  },
                                },
                              },
                            }}
                            />
                          </LocalizationProvider>
                          {isError && (
                            <ErrorContent
                              margin={"-5px 0px 0px"}
                              className="Mui-error"
                            >
                              {helperText}
                            </ErrorContent>
                          )}
                        </>
                      );
                    }}
                  </Field>
                )}
                
               

                {item.component === "calender" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <>
                          <DateRangePickerComp
                            startDateProp={values.Date_Range?.start_date}
                            endDateProp={values.Date_Range?.end_date}
                            handleChange={(start_date, end_date) => {
                              item.handleDatePicker(
                                item.titleName,
                                start_date,
                                end_date
                              );
                            }}
                            error={Boolean(errors["Date_Range"])}
                            customStyle={{
                              "& .rdrDefinedRangesWrapper": {
                                display: "none",
                              },
                            }}
                          />
                          {Boolean(errors["Date_Range"]) && (
                            <ErrorContent>{errors["Date_Range"]}</ErrorContent>
                          )}
                        </>
                      );
                    }}
                  </Field>
                )}

                {item.component === "autoComplete" && (
                  <CustomDiv>
                    <AutocompleteText
                      autoData={{
                        options: [],
                        key: `autocomplete-${index}`,
                        title: item.placeholder,
                        placeholder: item.placeholder,
                        isDisabled: false,
                        value: values[item.titleName] || "",

                        onDelete: (option) =>
                          item.handleDelete(option, item.titleName),
                        onKeyDown: (e) => {
                          item.handleAutoCompleteKeyDown(
                            e,
                            index,
                            item.titleName,
                            item.inputValue,
                            setFieldValue
                          );
                          if (e.key === "Tab") {
                            setLocalValue((prev) => ({
                              ...prev,
                              [item.inputValue]: "",
                            }));
                          }
                        },

                        onChange: (e, newValue) => {
                          item.handleAutoCompleteChange(
                            e,
                            newValue,
                            item.titleName
                          );
                        },
                        inputValue: localValue[item.inputValue],
                        onInputChange: (e, newValue) => {
                          setLocalValue((prev) => ({
                            ...prev,
                            [item.inputValue]: newValue,
                          }));
                        },
                        customClass: item.titleName,
                      }}
                      error={errors[item.titleName]}
                    />
                    {errors[item.titleName] && (
                      <ErrorContent>{errors[item.titleName]}</ErrorContent>
                    )}
                  </CustomDiv>
                )}
                {item.component === "multi-complete" && (
                  <CustomDiv>
                    <Autocomplete
                      multiple
                      options={values[item.options] || []}
                      getOptionLabel={(option) => option.name || option}
                      value={
                        values[item.titleName] &&
                        values[item.titleName]?.map(
                          (selected) =>
                            values[item.options]?.find(
                              (option) => option.id === selected.id
                            ) || []
                        )
                      }
                      onChange={(e, newValue) => {
                        item.handleAutoCompleteChange(
                          e,
                          newValue,
                          item.titleName
                        );
                      }}
                      limitTags={2}
                      renderTags={(value, getTagProps) =>
                        value &&
                        value.length !== 0 &&
                        value.map((option, index) => {
                          // Find the selected item from values[item.titleName] to get the name property
                          const selectedItem = values[item.titleName]?.find(
                            (selected) => selected.id === option.id
                          );
                          return (
                            <Chip
                              key={option.id || option.name + index}
                              variant={`outlined ${selectedItem?.color || ""}`}
                              border={selectedItem?.color ? "#D0D5DD" : "none"}
                              label={option.name || option}
                              {...getTagProps({ index })}
                            />
                          );
                        })
                      }
                      renderOption={(props, option, { selected }) => {
                        const isChecked = values[item.titleName]?.some(
                          (val) => val.name === option.name || selected
                        );

                        return (
                          <li {...props} style={{ padding: "3px 10px" }}>
                            <Checkbox checked={isChecked} />
                            {option.name || option}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={item.placeholder}
                          error={errors[item.titleName]}
                        />
                      )}
                      ListboxProps={{
                        id: "custom-autocomplete-list",
                      }}
                      disablePortal
                      disableCloseOnSelect
                      sx={{
                        "& label.MuiInputLabel-sizeMedium": {
                          top: "-5px !important",
                        },
                        "& label.MuiInputLabel-shrink": {
                          top: "0px !important",
                        },
                        "& .MuiInputBase-formControl": {
                          padding: "5px 39px 5px 9px",
                          gap: "4px",
                        },
                        "& fieldset": {
                          border: "1px solid #D0D5DD",
                        },
                        // "& .MuiChip-root": {
                        //   gap: "10px",
                        //   border: "1px solid",
                        //   "& .MuiChip-deleteIcon": {
                        //     width: "20px",
                        //   },
                        // },
                        "& .MuiAutocomplete-tag": {
                          gap: "5px",
                          margin: "0px 3px",
                          borderRadius: "5px",
                          fontSize: "12px",
                          border: "1px solid",
                          padding: "2px 6px",
                        },
                        "& .extracted": {
                          background: "rgba(0, 0, 0, 0.08)",
                        },
                        "& .inferred": {
                          color: "rgb(0, 112, 242)",
                          background: "rgb(235, 248, 255)",
                          border: "1px solid rgb(0, 112, 242)",
                        },
                        "& .user_added": {
                          color: "rgb(7, 148, 85)",
                          background: "rgb(219, 250, 230)",
                          border: "1px solid rgb(7, 148, 85)",
                        },
                      }}
                    />
                    {errors[item.titleName] && (
                      <ErrorContent>{errors[item.titleName]}</ErrorContent>
                    )}
                  </CustomDiv>
                )}

                {item.component === "input-list" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          placeholder={item.title}
                          padding="10px"
                          // onBlur={handleBlur}
                          error={Boolean(errors[item.titleName]?.[index])}
                          helperText={errors[item.titleName]?.[index]}
                          value={localValue[item.titleName]?.[index] || ""}
                          defaultValue={item.name}
                          onChange={(e) => {
                            handleListChange(e, item, index);
                          }}
                        />
                      );
                    }}
                  </Field>
                )}
              </>
            )}
          </CommonGrid2>
        );
      })}
    </CommonGrid2>
  );
};
export default EditIndex;
